import {onBeforeMount, Ref} from 'vue';
import {SetupLinkIndexReturn} from '../../common/LinkIndex';
import {ParamsStackPanelInitLayoutData, ParamsStackItemData, SerializedParamsStackItemData} from '../../../../types';
import {StoreController} from '../../../../store/controllers/StoreController';
import {CoreType} from '../../../../../../@polygonjs/polygonjs/src/core/Type';

export interface ParamsStackPanelProps {
	panelId: string;
	// nodeId: CoreGraphNodeId;
	init_layout_data: ParamsStackPanelInitLayoutData;
}
export interface SetupLayoutDataOptions {
	props: ParamsStackPanelProps;
	setupLinkIndex: SetupLinkIndexReturn;
	stack: Ref<ParamsStackItemData[]>;
}

export function SetupLayoutData(options: SetupLayoutDataOptions) {
	const {props, setupLinkIndex, stack} = options;
	onBeforeMount(() => {
		fromJSON(props.init_layout_data);
	});

	function fromJSON(json: ParamsStackPanelInitLayoutData) {
		setupLinkIndex.fromJSON(json);

		const serializedStack = json.serializedStack;
		if (serializedStack != null && CoreType.isArray(serializedStack)) {
			for (let item of json.serializedStack) {
				const node = StoreController.scene.node(item.nodePath);
				if (node) {
					stack.value.push({
						nodeId: node.graphNodeId(),
						expanded: item.expanded,
					});
				}
			}
		}
	}

	function layoutData() {
		const serializedStack: SerializedParamsStackItemData[] = [];
		for (let item of stack.value) {
			const node = StoreController.engine.node(item.nodeId);
			if (node) {
				serializedStack.push({
					nodePath: node.path(),
					expanded: item.expanded,
				});
			}
		}
		return {
			...setupLinkIndex.toJSON(),
			serializedStack,
		};
	}

	return {fromJSON, layoutData};
}
